import {
  DiscoveryAssistantMode,
  DiscoveryUserMode,
  type AssistantLoadingMessage,
  type FilterConditions,
  type UserCommonalityPostListItem,
  type UserPostsMessage,
  type UserPromptMessage,
} from '@/entities/discovery';
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';

export const buildUserPromptMessage = (
  sessionId: string,
  prompt: string,
  filterConditions: FilterConditions,
): UserPromptMessage => {
  return {
    message_id: uuidv4().toString(),
    discovery_session_id: sessionId,
    role: 'user',
    user_mode: DiscoveryUserMode.PROMPT,
    content: {
      message: prompt,
      filter_conditions: filterConditions,
    },
    created_at: dayjs().toISOString(),
  };
};

export const buildUserPostsMessage = (
  sessionId: string,
  post_list: Array<UserCommonalityPostListItem>,
  filterConditions: FilterConditions,
): UserPostsMessage => {
  return {
    message_id: uuidv4().toString(),
    discovery_session_id: sessionId,
    role: 'user',
    user_mode: DiscoveryUserMode.POSTS,
    content: {
      post_list: post_list,
      filter_conditions: filterConditions,
    },
    created_at: dayjs().toISOString(),
  };
};

export const buildAssistantLoadingMessage = (sessionId: string): AssistantLoadingMessage => {
  return {
    message_id: uuidv4().toString(),
    discovery_session_id: sessionId,
    role: 'assistant',
    assistant_mode: DiscoveryAssistantMode.LOADING,
    content: {
      message: 'Analyzing your request...',
    },
    created_at: dayjs().toISOString(),
  };
};
